// Module
var code = "bla bla bla";
// Exports
module.exports = code;